module.exports = __webpack_public_path__ + "img/daren_2.ba822eb0.png";